export const dontEmojis = /^[a-zA-Z0-9_!@#$%^&*(),.?":{}|<>'’= -]*$/
export const RegexEspecial = /^[a-zA-Z0-9\s\S]*$/
export const RegexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const dontSemicolons = /^[^;]*$/
